import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// local components
import Layout from "../../core/Layout";

import resources from "../../core/Localization/Localization.js";
import CustomDataGrid from "../../components/CustomDataGrid/CustomDataGrid2";
import { versionColumns } from "../../common/DataGridColumns/Versions";
import { handleTableLoad } from "../../common/VersionsTableData";

import { getPaginationVersions } from "../../reduxStore/entities/versions";

export default function Versions() {
    const navigate = useNavigate();
    const columns = React.useMemo(versionColumns, [resources]);

    // Store hooks
    const versions = useSelector((state) => state.versions.versions);
    const count = useSelector((state) => state.versions.count);
    const dataLoaded = useSelector((state) => state.versions.dataLoaded);
    const dispatch = useDispatch();

    // State hooks
    const [rows, setRows] = React.useState(handleTableLoad(versions));
    const [totalRows, setTotalRows] = React.useState(count);
    const [currentFilters, setCurrentFilters] = React.useState(null);

    // React hooks
    useEffect(() => setTotalRows(count), [count]);
    useEffect(() => setRows(handleTableLoad(versions)), [versions, dataLoaded]);
    // useEffect(() => {
    //     const notificationListener = notifications.subscribe(notificationTypes.userCreated, handler);
    //     return () => {
    //         notificationListener.unsubscribe();
    //     };
    // }, [currentFilters]);

    const handler = (message) => {
        if (currentFilters) {
            dispatch(getPaginationVersions(currentFilters));
        }

        else {
            dispatch(getPaginationVersions());
        };
    };

    // Event handlers
    const onFiltersChanged = (filters) => doSearchVersions(filters);

    const onPageChange = (filters) => {
        doSearchVersions(filters);
    };

    const onRowClick = (id) => {
        window.open("/admin/versions/" + id, "_blank");
    };

    const onAddButtonClick = () => navigate("/admin/versions/create");

    // Private (helper) functions
    const doSearchVersions = (filters) => {
        // if (filters?.columnField === "role" && !!filters?.value) {
        //     filters.value = filterUserRoles(filters.value);
        // }
        setCurrentFilters({ ...filters });
        dispatch(getPaginationVersions(filters));
        setRows(handleTableLoad(versions));
    };

    return (
        <Layout showAddButton={true} onAdd={() => onAddButtonClick()}>
            <CustomDataGrid
                title={resources.versionList.title}
                rows={rows}
                columns={columns}
                totalRows={totalRows}
                loading={!dataLoaded}
                handleRowClick={onRowClick}
                handleFilterChange={onFiltersChanged}
                handlePageChange={onPageChange}
                handleDataInit={doSearchVersions}
                ignoreUrl={false}
            />
        </Layout>
    );
}
